import { render } from "./Downloads.vue?vue&type=template&id=41a6f6cc&scoped=true"
import script from "./Downloads.vue?vue&type=script&lang=js"
export * from "./Downloads.vue?vue&type=script&lang=js"

import "./Downloads.vue?vue&type=style&index=0&id=41a6f6cc&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a6f6cc"]])

export default __exports__